import { apiRequest, createMutationIdempotencyKey } from '../http.js'

export const billingApi = {
  getSummary: async (options = {}) => {
    const data = await apiRequest('/billing/summary', options)
    return data.summary
  },
  createCheckoutSession: async ({ interval = 'year' } = {}) => {
    const data = await apiRequest('/billing/checkout-session', {
      method: 'POST',
      body: JSON.stringify({ interval }),
      idempotencyKey: createMutationIdempotencyKey('billing-checkout'),
    })
    return data.checkout
  },
  createPortalSession: async () => {
    const data = await apiRequest('/billing/portal-session', {
      method: 'POST',
      body: JSON.stringify({}),
      idempotencyKey: createMutationIdempotencyKey('billing-portal'),
    })
    return data.portal
  },
}
